import produce from 'immer';
import { isChatInWaitingQueue } from '../../utils/fuctions/mapSituationChat';

const INITIAL_STATE = {
  conversations: []
};

export default function conversation(state = INITIAL_STATE, action) {
  // console.log('##### REDUCER ANSWERED CONVERSAION #####');
  switch (action.type) {
    case '@ANSWERED_CONVERSATION/ADD_INIT_CONVERSATIONS':
      return produce(state, (draft) => {
        draft.conversations = action.payload.conversations;
      });
    case '@ANSWERED_CONVERSATION/ADD_CONVERSATION':
      return produce(state, (draft) => {
        const chatId =
          action.payload.conversation?._id ?? action.payload.conversation.id;
        if (isChatInWaitingQueue(action.payload.conversation?.situacao)) {
          return;
        }
        const index = draft.conversations.findIndex(
          (c) => (c._id ?? c?.id) === chatId
        );

        if (index < 0) draft.conversations.push(action.payload.conversation);
        else draft.conversations[index] = action.payload.conversation;
      });
    case '@ANSWERED_CONVERSATION/REMOVE_CONVERSATION':
      return produce(state, (draft) => {
        const conversationIndex = draft.conversations.findIndex((c) => {
          const id = c?._id ?? c.id;
          return id === action.payload.id;
        });
        if (conversationIndex >= 0) {
          draft.conversations.splice(conversationIndex, 1);
        }
      });
    case '@ANSWERED_CONVERSATION/ADD_MESSAGE_ANSWERED_CONVERSATION':
      return produce(state, (draft) => {
        const index = draft.conversations.findIndex(
          (c) => (c._id ?? c?.id) === action?.payload?.idDaConversa
        );

        if (index < 0) return;

        draft.conversations[index].mensagens.push(action.payload.message);
        draft.conversations[index].novas_mensagens =
          action.payload.novas_mensagens;
      });
    default:
      return state;
  }
}
